import { z } from 'zod';

export const FrameTemplateSchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  name: z.string(),
  frame_type: z.string(),
  default_width: z.number(),
  default_height: z.number(),
  default_depth: z.number(),
  frame_config: z.string(),
  construction_notes: z.string().nullable(),
  active: z.boolean(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateFrameTemplateSchema = z.object({
  code: z.string().min(1, 'Code is required'),
  name: z.string().min(1, 'Name is required'),
  frame_type: z.string().default('general'),
  default_width: z.number().default(36),
  default_height: z.number().default(30),
  default_depth: z.number().default(24),
  frame_config: z.string().default('{}'),
  construction_notes: z.string().nullable().optional(),
  active: z.boolean().default(true),
});

export const UpdateFrameTemplateSchema = CreateFrameTemplateSchema.partial();

export type FrameTemplate = z.infer<typeof FrameTemplateSchema>;
export type CreateFrameTemplate = z.infer<typeof CreateFrameTemplateSchema>;
export type UpdateFrameTemplate = z.infer<typeof UpdateFrameTemplateSchema>;
